/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BatchCreate,
  BatchRead,
  CreateBatchParams,
  GetBatchesParams,
  HTTPValidationError,
  PageBatchWithOwnerAndWarehouseVendor,
  UpdateBatchInvoiceUrlParams,
  UpdateBatchNoteParams,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new batch.
 * @summary Create Batch
 */
export const createBatch = (
  batchCreate: BatchCreate,
  params?: CreateBatchParams,
  signal?: AbortSignal,
) => {
  return customInstance<number>({
    url: `/api/batch/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: batchCreate,
    params,
    signal,
  });
};

export const getCreateBatchMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBatch>>,
    TError,
    { data: BatchCreate; params?: CreateBatchParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBatch>>,
  TError,
  { data: BatchCreate; params?: CreateBatchParams },
  TContext
> => {
  const mutationKey = ["createBatch"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBatch>>,
    { data: BatchCreate; params?: CreateBatchParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return createBatch(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBatch>>
>;
export type CreateBatchMutationBody = BatchCreate;
export type CreateBatchMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Batch
 */
export const useCreateBatch = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBatch>>,
      TError,
      { data: BatchCreate; params?: CreateBatchParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBatch>>,
  TError,
  { data: BatchCreate; params?: CreateBatchParams },
  TContext
> => {
  const mutationOptions = getCreateBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many batches.

Results are paginated.
 * @summary Get Batches
 */
export const getBatches = (params?: GetBatchesParams, signal?: AbortSignal) => {
  return customInstance<PageBatchWithOwnerAndWarehouseVendor>({
    url: `/api/batch/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBatchesQueryKey = (params?: GetBatchesParams) => {
  return ["api", "batch", ...(params ? [params] : [])] as const;
};

export const getGetBatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatches>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatches>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatches>>> = ({
    signal,
  }) => getBatches(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBatches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatches>>
>;
export type GetBatchesQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBatches<
  TData = Awaited<ReturnType<typeof getBatches>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetBatchesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatches>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatches>>,
          TError,
          Awaited<ReturnType<typeof getBatches>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBatches<
  TData = Awaited<ReturnType<typeof getBatches>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatches>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatches>>,
          TError,
          Awaited<ReturnType<typeof getBatches>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBatches<
  TData = Awaited<ReturnType<typeof getBatches>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatches>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Batches
 */

export function useGetBatches<
  TData = Awaited<ReturnType<typeof getBatches>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatches>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBatchesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an batch by ID.
 * @summary Get Batch
 */
export const getBatch = (batchId: number, signal?: AbortSignal) => {
  return customInstance<BatchRead>({
    url: `/api/batch/${batchId}`,
    method: "GET",
    signal,
  });
};

export const getGetBatchQueryKey = (batchId?: number) => {
  return ["api", "batch", batchId] as const;
};

export const getGetBatchQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  batchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBatchQueryKey(batchId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatch>>> = ({
    signal,
  }) => getBatch(batchId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!batchId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetBatchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatch>>
>;
export type GetBatchQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBatch<
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  batchId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatch>>,
          TError,
          Awaited<ReturnType<typeof getBatch>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBatch<
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  batchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatch>>,
          TError,
          Awaited<ReturnType<typeof getBatch>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBatch<
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  batchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Batch
 */

export function useGetBatch<
  TData = Awaited<ReturnType<typeof getBatch>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  batchId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBatch>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBatchQueryOptions(batchId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an batch by ID.
 * @summary Update Batch
 */
export const updateBatch = (batchId: number, batchCreate: BatchCreate) => {
  return customInstance<unknown>({
    url: `/api/batch/${batchId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: batchCreate,
  });
};

export const getUpdateBatchMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatch>>,
    TError,
    { batchId: number; data: BatchCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBatch>>,
  TError,
  { batchId: number; data: BatchCreate },
  TContext
> => {
  const mutationKey = ["updateBatch"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBatch>>,
    { batchId: number; data: BatchCreate }
  > = (props) => {
    const { batchId, data } = props ?? {};

    return updateBatch(batchId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBatch>>
>;
export type UpdateBatchMutationBody = BatchCreate;
export type UpdateBatchMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Batch
 */
export const useUpdateBatch = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBatch>>,
      TError,
      { batchId: number; data: BatchCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBatch>>,
  TError,
  { batchId: number; data: BatchCreate },
  TContext
> => {
  const mutationOptions = getUpdateBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete a batch by ID.
 * @summary Delete Batch
 */
export const deleteBatch = (batchId: number) => {
  return customInstance<unknown>({
    url: `/api/batch/${batchId}`,
    method: "DELETE",
  });
};

export const getDeleteBatchMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBatch>>,
    TError,
    { batchId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBatch>>,
  TError,
  { batchId: number },
  TContext
> => {
  const mutationKey = ["deleteBatch"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBatch>>,
    { batchId: number }
  > = (props) => {
    const { batchId } = props ?? {};

    return deleteBatch(batchId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBatch>>
>;

export type DeleteBatchMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Batch
 */
export const useDeleteBatch = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBatch>>,
      TError,
      { batchId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBatch>>,
  TError,
  { batchId: number },
  TContext
> => {
  const mutationOptions = getDeleteBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update an batch note by ID.
 * @summary Update Batch Note
 */
export const updateBatchNote = (
  batchId: number,
  params: UpdateBatchNoteParams,
) => {
  return customInstance<unknown>({
    url: `/api/batch/${batchId}/note`,
    method: "PUT",
    params,
  });
};

export const getUpdateBatchNoteMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchNote>>,
    TError,
    { batchId: number; params: UpdateBatchNoteParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBatchNote>>,
  TError,
  { batchId: number; params: UpdateBatchNoteParams },
  TContext
> => {
  const mutationKey = ["updateBatchNote"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBatchNote>>,
    { batchId: number; params: UpdateBatchNoteParams }
  > = (props) => {
    const { batchId, params } = props ?? {};

    return updateBatchNote(batchId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBatchNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBatchNote>>
>;

export type UpdateBatchNoteMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Batch Note
 */
export const useUpdateBatchNote = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBatchNote>>,
      TError,
      { batchId: number; params: UpdateBatchNoteParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBatchNote>>,
  TError,
  { batchId: number; params: UpdateBatchNoteParams },
  TContext
> => {
  const mutationOptions = getUpdateBatchNoteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update an batch invoice_url by ID.
 * @summary Update Batch Invoice Url
 */
export const updateBatchInvoiceUrl = (
  batchId: number,
  params: UpdateBatchInvoiceUrlParams,
) => {
  return customInstance<unknown>({
    url: `/api/batch/${batchId}/invoice_url`,
    method: "PUT",
    params,
  });
};

export const getUpdateBatchInvoiceUrlMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBatchInvoiceUrl>>,
    TError,
    { batchId: number; params: UpdateBatchInvoiceUrlParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBatchInvoiceUrl>>,
  TError,
  { batchId: number; params: UpdateBatchInvoiceUrlParams },
  TContext
> => {
  const mutationKey = ["updateBatchInvoiceUrl"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBatchInvoiceUrl>>,
    { batchId: number; params: UpdateBatchInvoiceUrlParams }
  > = (props) => {
    const { batchId, params } = props ?? {};

    return updateBatchInvoiceUrl(batchId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBatchInvoiceUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBatchInvoiceUrl>>
>;

export type UpdateBatchInvoiceUrlMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Batch Invoice Url
 */
export const useUpdateBatchInvoiceUrl = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBatchInvoiceUrl>>,
      TError,
      { batchId: number; params: UpdateBatchInvoiceUrlParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBatchInvoiceUrl>>,
  TError,
  { batchId: number; params: UpdateBatchInvoiceUrlParams },
  TContext
> => {
  const mutationOptions = getUpdateBatchInvoiceUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
